import React from 'react';
import './index.css';
import App from './App.jsx';
import * as Sentry from "@sentry/react";
import { createRoot } from 'react-dom/client';

Sentry.init({
  dsn: "https://bc9e4bc67a4d53bd67d388803ff98103@o4509957842534400.ingest.us.sentry.io/4509957843517440",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.register();

// caches.keys().then(function(names) {
//     for (let name of names) {
//         caches.delete(name);
//     }
// });

// navigator.serviceWorker.getRegistrations().then(registrations => {
//     for (const registration of registrations) {
//         console.log(registration)
//         registration.unregister();
//     }
// });